import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Snackbar from '@mui/material/Snackbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

export type SnackbarType = 'error' | 'warning' | 'success' | 'info'
type AnchorHorizontalType = 'left' | 'center' | 'right'
type AnchorVerticalType = 'top' | 'bottom'
type PositionType = {
    vertical: AnchorVerticalType
    horizontal: AnchorHorizontalType
}
type SnackbarProps = {
    onClose?: () => void
    message: string
    isOpen: boolean
    autoHide?: boolean
    disableClickOutside?: boolean
    autoHideDuration?: number
    type?: SnackbarType
    position?: PositionType
    overrideClass?: {}
}

const SnackbarControl = (props: SnackbarProps) => {
    const {
        onClose,
        message,
        isOpen,
        autoHide = true,
        disableClickOutside = false,
        autoHideDuration = 6000,
        type = 'info',
        position = { vertical: 'top', horizontal: 'center' },
        overrideClass,
    } = props
    const classes = useStyles()

    const handleClose = (event: any, reason: string) => {
        if (reason === 'clickaway') {
            return
        }

        onClose?.()
    }

    const action = (
        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon fontSize="small" />
        </IconButton>
    )

    return (
        <Snackbar
            onClose={() => (disableClickOutside ? handleClose : onClose?.())}
            message={message}
            open={isOpen}
            autoHideDuration={autoHide ? autoHideDuration : undefined}
            anchorOrigin={position}
            action={action}
            ContentProps={{
                className:
                    type === 'error'
                        ? classes.snackbarError
                        : type === 'warning'
                        ? classes.snackbarWarning
                        : type === 'success'
                        ? classes.snackbarSuccess
                        : classes.snackbarInfo,
            }}
        />
    )
}

export default SnackbarControl

const useStyles = makeStyles((theme: Theme) => ({
    snackbarInfo: {
        backgroundColor: `${theme.palette.primary.dark} !important`,
        color: `${theme.palette.text.secondary} !important`,
    },
    snackbarSuccess: {
        backgroundColor: `${theme.palette.getContrastText('green')} !important`,
        color: `${theme.palette.text.primary} !important`,
    },
    snackbarWarning: {
        backgroundColor: `${theme.palette.getContrastText('yellow')} !important`,
        color: `${theme.palette.text.primary} !important`,
    },
    snackbarError: {
        backgroundColor: `${theme.palette.getContrastText('fail')} !important`,
        color: `${theme.palette.text.secondary} !important`,
    },
}))
